// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__zwWtl","feature":"image_feature__B2Qh5","square":"image_square__2aytg","poster":"image_poster__5X1xF","standard":"image_standard__N8GoE"};